import Typography, { TypographyProps } from "@vahak/core-ui/dist/components/Typography";
import COLORS from "@vahak/core-ui/dist/constants/colors";
import Flex from "@vahak/core-ui/dist/layout/Flex";
import React from "react";
import { ReactNode } from "react";

interface LabelValueProps {
    label: ReactNode;
    value: ReactNode;
    maxWidth?: string;
    labelProps?: Partial<TypographyProps>;
    valueProps?: Partial<TypographyProps>;
    gap?: number;
    direction?: "row" | "column";
}
const LabelValue = ({ label, value, maxWidth, labelProps, valueProps, gap = 12, direction }: LabelValueProps) => {
    return (
        <Flex flexDirection={direction || "column"} style={{ maxWidth: maxWidth }} gap={gap}>
            <Typography color={COLORS.GREY_700} {...labelProps}>
                {label}
            </Typography>
            <Typography color={COLORS.GREY_1000} weight="medium" {...valueProps}>
                {value}
            </Typography>
        </Flex>
    );
};

export default LabelValue;
